// extracted by mini-css-extract-plugin
export default {"forecast__current":"ForecastNow_forecast__current__eCXqq"};